// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
	{
		return true;
	}

	const {fields} = state;

	if (!fields.is_company && (
		fields.customer_email.length <= 0 || !Validator.validateEmail(fields.customer_email)
	))
	{
		return false;
	}

	if (fields.customer_ssn.length <= 0)
	{
		return false;
	}

	if (fields.customer_firstname.length <= 0)
	{
		return false;
	}

	if (!fields.is_company && fields.customer_lastname.length <= 0)
	{
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fullmakt/Fullmaktsgivare.fulfillment.js